module.exports = {
      id: "header_logo-usage",
      viewBox: "0 0 78 68",
      url: __webpack_public_path__ + "svg-sprite-39ec39c5b3d32c0adb9732979a5c9627.svg#header_logo",
      toString: function () {
        return this.url;
      }
    }